/*
 * @Author: Src
 * @Date: 2025-06-20 17:37:38
 * @LastEditTime: 2025-06-20 17:42:28
 * @LastEditors: Src
 * @FilePath: /work-station/src/store/modules/pageSize.ts
 * @Description: 头部注释配置模板
 */
import { Module } from 'vuex';
import { RootState } from '../types';
// 定义模块的 State 类型
export interface PageSizeState {
  pageSize: string[];
}

const pageSizeModule: Module<PageSizeState, RootState> = {
  namespaced: true,
  state: {
    pageSize: ['10', '20', '50', '100', '200'],
  },
  mutations: {
    SET_PAGE_SIZE(state: PageSizeState, payload: string[]) {
      state.pageSize = payload;
    },
  },
  actions: {
    updatePageSize({ commit }, pageSize: string[]) {
      commit('SET_PAGE_SIZE', pageSize);
    },
  },
  getters: {
    pageSize(state) {
      return state.pageSize;
    },
  },
};

export default pageSizeModule;
